// extracted by mini-css-extract-plugin
export var StickyCTA = "sticky-cta-module--StickyCTA--92c98";
export var StickyCTAAction = "sticky-cta-module--StickyCTAAction--21249";
export var StickyCTAArrow = "sticky-cta-module--StickyCTAArrow--e9984";
export var StickyCTAContent = "sticky-cta-module--StickyCTAContent--d2d1a";
export var StickyCTATitle = "sticky-cta-module--StickyCTATitle--840ab";